import { type ProductModifierGroup } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export function checkIfModificationGroupNotEmpty(
  modifierGroup: ProductModifierGroup,
): boolean {
  return modifierGroup.modifications.length > 0;
}
